import { createSlice } from "@reduxjs/toolkit";
import {
  addBrands,
  fetchBrandsAttributes,
  fetchBrandsById,
  updateBrands,
  updateStatusInBrands,
} from "./thunk";

interface CategoryState {
  brandList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedCategories: any;
}

const initialState: CategoryState = {
  brandList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedCategories: null,
};

const categorySlice = createSlice({
  name: "brand",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBrandsAttributes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBrandsAttributes.fulfilled, (state, action) => {
        state.loading = false;
        state.brandList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchBrandsAttributes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Categories";
      })
      .addCase(fetchBrandsById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBrandsById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCategories = action.payload;
      })
      .addCase(fetchBrandsById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addBrands.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.brandList = state.brandList.map((brand) =>
          brand.id === action.payload.id ? action.payload : brand
        );
      })
      .addCase(addBrands.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateBrands.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.brandList = state.brandList.map((brand) =>
          brand.id === action.payload.id ? action.payload : brand
        );
      })
      .addCase(updateBrands.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateStatusInBrands.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        // state.categoryList = state.categoryList.map((category) =>
        //   category.id === action.payload.id ? action.payload : category
        // );
      })
      .addCase(updateStatusInBrands.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      });
  },
});

export default categorySlice.reducer;
